import { render, staticRenderFns } from "./AddDataEntry.vue?vue&type=template&id=0b580d1c"
import script from "./AddDataEntry.vue?vue&type=script&lang=js"
export * from "./AddDataEntry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports